import React from 'react';

class FilterImage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filter_type: props.filter_type,
      filter_gradient_from: props.filter_gradient_from,
      filter_gradient_to: props.filter_gradient_to,
    };
  }

  shouldComponentUpdate(nextProps) {
    const bg = document.querySelector('#hu-filter .hu-filter-image');
    if (nextProps.filter_type !== 'image')
      bg.className = bg.className.replace(/\sselected/g, '');
    else 
      bg.className = 'hu-filter-image' + ' selected';
    return false;
  }

  render() {
    const { filter_type } = this.props;
    const selected = filter_type === 'image';
    
    return (
      <div className={ selected ? 'hu-filter-image selected' : 'hu-filter-image' }></div>
    );
  }
}

export default FilterImage;


// WEBPACK FOOTER //
// ./app/js/components/filter/FilterImage.js